import React, { FunctionComponent, PropsWithChildren } from "react";
import { LiveProvider, LiveEditor, LiveError, LivePreview } from "react-live";
import * as uif from "@episerver/ui-framework";

import "./demo.scss";

const {
    ExpandableCard,
    ExpandedCardContentArea,
    CardContentArea,
    Grid,
    GridCell
} = uif;

type AcceptedLanguages = "jsx" | "markup" | "typescript" | "javascript";

interface DemoItem {
    code: string;
    language?: AcceptedLanguages;
    noInline?: boolean;
}

interface DemoProps {
    demo: DemoItem;
}

// we're constructing an empty theme object so that react-live will not set
// default values that will interfere with our prismjs theme.
const theme = {
    plain: {
        fontFamily: "",
        fontSize: ""
    },
    styles: []
};

export const Demo: FunctionComponent<PropsWithChildren<DemoProps>> = ({
    children,
    demo
}) => (
    // Use the Grid to simulate a Workspace.
    <LiveProvider {...{ theme, scope: uif, ...demo }}>
        <ExpandableCard className="ds-demo">
            <CardContentArea>
                <Grid>
                    <LivePreview className="styled-preview" Component={GridCell} />
                </Grid>
            </CardContentArea>
            <ExpandedCardContentArea expandText="Show code" collapseText="Hide code">
                <Grid>
                    <GridCell>
                        <LiveEditor className="styled-editor" />
                        <LiveError />

                        <h3>Props</h3>
                        {children}
                    </GridCell>
                </Grid>
            </ExpandedCardContentArea>
        </ExpandableCard>
    </LiveProvider>
);
